import axios from 'axios';

export function request(path, method = 'GET', content = {}, pending = false, pendingMessage = 'Loading...') {
    // Detect FormData and send without JSON.stringify or content-type override
    const isFormData = content instanceof FormData;

    return axios({
        method,
        url: process.env.REACT_APP_INFRA_BACK_ENDPOINT + path,
        data: isFormData ? content : JSON.stringify(content),
        headers: isFormData ? undefined : { 'Content-Type': 'application/json' },
    });
}


export function get(path, pending = false, pendingMessage = 'Loading...') {
    return request(path, 'GET', {}, pending, pendingMessage);
}


export function patch(path, content = {}) {
    return request(path, 'PATCH', content);
}

export function post(path, content = {}, pending = false, pendingMessage = 'Loading...', attachments = []) {

    // If attachments are provided → always send as FormData
    if (attachments?.length > 0) {
        const form = new FormData();
        form.append('payload', JSON.stringify(content || {}));
        attachments.forEach((file) => {
            if (file) {
                form.append('attachments', file);
            }
        });
        return request(path, 'POST', form, pending, pendingMessage);
    }

    // No attachments → normal JSON flow
    return request(path, 'POST', content, pending, pendingMessage);
}


export function isValidHttpsUrl(u) {
    if (!u || typeof u !== 'string') {
        return false;
    }
    const s = u.trim();
    if (s.length <= 'https://'.length) {
        return false; // requires something after scheme
    }
    try {
        const url = new URL(s);
        return url.protocol === 'https:';
    } catch {
        return false;
    }
}


/**
 * Checks if a string is a valid URL, supporting both protocol-led (https://)
 * and shorthand (www.) links.
 */

export function isValidUrl(u) {
    if (!u || typeof u !== 'string') return false;
    const s = u.trim();
    
    // Check for protocol-less www. links
    if (/^www\./i.test(s)) return true;

    try {
        const url = new URL(s);
        return ['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol);
    } catch {
        return false;
    }
}

/**
 * Ensures a URL has a protocol for the <a> tag's href attribute.
 */
export function ensureProtocol(url) {
    if (/^www\./i.test(url)) return `https://${url}`;
    return url;
}

/**
 * Validates video extensions
 */
export function isVideoUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\.(mp4|mov|webm|ogg|m4v)$/i.test(url);
};


export async function downloadFile(path, filename) {
    const res  = await axios.get(process.env.REACT_APP_INFRA_BACK_ENDPOINT + path, { responseType: 'blob' });
    const url  = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href     = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export function safeOpenUrl(u, e) {
    if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
    }
    if (!isValidHttpsUrl(u)) {
        return;
    }
    window.open(u.trim(), '_blank', 'noopener');
}
